













import {Vue, Component, Prop} from 'vue-property-decorator';

@Component({
    name: 'ProjectBlock',
})
export default class ProjectBlock extends Vue {
    @Prop({required: true}) public image!: string;
    @Prop({required: true}) public title!: string;
    @Prop({required: true}) public description!: string;
    @Prop({default: '/'}) public path!: string;
}
